const lenis = new Lenis({
  duration: 0.8,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
  direction: 'vertical', // vertical, horizontal
  gestureDirection: 'vertical', // vertical, horizontal, both
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
})


//get scroll value
/*lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
  console.log({ scroll, limit, velocity, direction, progress })
})*/

function raf(time) {
  lenis.raf(time)
    /*ScrollTrigger.update();*/
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)  

gsap.registerPlugin(ScrollTrigger);

CustomEase.create("pasiego", ".6,.04,.26,.96");
CustomEase.create("pasiego2", ".215,.61,.355,1");


gsap.utils.toArray(".translate").forEach(section => {
  gsap.from(section.querySelectorAll("p"), {
    scrollTrigger: section,
    autoAlpha: 0.2,
    
    duration: 0.75,
    stagger: 0.25,
      ease: "pasiego"
  });
});

gsap.utils.toArray(".translate2").forEach(section => {
  gsap.from(section.querySelectorAll("p"), {
    scrollTrigger: section,
    autoAlpha: 0,
    
    duration: 0.75,
    stagger: 0.25,
      ease: "pasiego"
  });
});


gsap.utils.toArray('.footer-menu').forEach(section => {
  const elems = section.querySelectorAll('span');
  
  // Set things up
  gsap.set(elems, { y: 50, opacity: 0 });
  
  ScrollTrigger.create({
    trigger: section,
    start: 'bottom bottom',
     
    onEnter: () => gsap.to(elems, {
      y: 0,
      opacity: 1,
      duration: 1.2,
      stagger: 0.15,
      delay: .4,
      ease: "pasiego2",
      overwrite: 'auto'
    }),
    onLeaveBack: () => gsap.to(elems, {
      y: 50,
      opacity: 0,
      duration: 1.2,
      stagger: 0.15,
      delay: .4,
      ease: "pasiego2",
      overwrite: 'auto'
    })
  });
});


gsap.utils.toArray('.anim2').forEach(section => {
  const elems = section.querySelectorAll('span');
  
  // Set things up
  gsap.set(elems, { y: 20, opacity: 0 });
  
  ScrollTrigger.create({
    trigger: section,
    start: 'top bottom',
     
    onEnter: () => gsap.to(elems, {
      y: 0,
      opacity: 1,
      duration: .2,
      stagger: 0.1,
      delay: 0.1,
      ease: "pasiego2",
      overwrite: 'auto'
    }),
    onLeaveBack: () => gsap.to(elems, {
      y: 20,
      opacity: 0,
      duration: .2,
      stagger: 0.1,
      delay: 0,
      ease: "pasiego2",
      overwrite: 'auto'
    })
  });
})

//HEADER ANIMATION
var scrollUp = document.querySelector('.header');

ScrollTrigger.create({

    scrub: true,
    start: '95%',
    end: 99999,
    trigger: ".hero",

    toggleClass: {
        className: 'header--scrolled',
        targets: '.header'
    }

});




ScrollTrigger.create({
  start: 'top 0',
  end: 99999,
  toggleClass: {className: 'nav--up', targets: '.nav'},
  onUpdate: ({direction}) => {
    if (direction == -1) {
      scrollUp.classList.remove('nav--up');
    } else {
      scrollUp.classList.add('nav--up');
    }}
});

//HEADER SCALE ANIMATION

gsap.to('.nav-size .nav-logo img', {
  scale: .7,
  duration: 1,
  scrollTrigger: {
    
    scrub: true,
    start: '0% 0%',
      trigger: ".header-anim",
  }
})

// ANIMATE HERO

gsap.to('.hero-bg', {
  scale: 1.1,
  duration: 1,
  scrollTrigger: {
   
   
    scrub: true,
    start: '0% 0%',
      trigger: ".header-anim",
  }
});

gsap.to('.hero-text, .hero-copy', {
  opacity: 0,
  duration: 1,
  scrollTrigger: {
    
    scrub: true,
    start: '0% 0%',
      trigger: ".header-anim",
  }
})

/// COPY TEXT


function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text); 

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

document.querySelector(".copy").onclick = function() {
    var result = copyToClipboard('hello@paisana.studio');
    document.querySelector(".footer-talk_msg").innerHTML = "Copied!";
};


/// FOOTER REVEAL
ScrollTrigger.create({
  trigger: ".footer",
  pin: true,
  start: "top top",
  end: "+=100%",
    
});

gsap.fromTo('.hero-cover', {
    rotation: 5,
    scaleY: 1.5,
    scaleX: 2.5,
    y: "-10%",
}, {
    delay: .3,
    duration: 1.4,
    scaleY: 0,
    y:0,
    rotation: 0,
    ease: "pasiego2",
});

gsap.fromTo('.hero-bg_anim', {
    scale: 1.2,
    y: "20%",
}, {
    delay: .3,
    duration: 1.4,
    y:0,
    scale:1,
    ease: "pasiego2",
});

gsap.fromTo('.hero .text', {
    opacity: 0,
}, {
    delay: .6,
    duration: .9,
    y: 0,
    rotation: 0,
    opacity: 1,
    ease: "pasiego2",
    stagger: {
        from: 'start',
        amount: 0.3,
    },
});


gsap.fromTo('.about-hero .text', {
    opacity: 0,
}, {
    delay: .1,
    duration: .9,
    y: 0,
    rotation: 0,
    opacity: 1,
    ease: "pasiego2",
    stagger: {
        from: 'start',
        amount: 0.3,
    },
});

gsap.fromTo('.about-clients_content ul li', 
    { '--scaleX': 0 },
    { 
        '--scaleX': 1,
        duration: 1.4,
        ease: "pasiego2",
        stagger: {
            from: 'start',
            amount: 0.3,
        },
         scrollTrigger: {
          trigger: '.about-clients',
          start: 'top 80%', 
               toggleActions: 'play reset play reset',
        }
    }
);

gsap.fromTo('.about-methodology__image img', { 
    y: '-105%',
    scale:1.1
    },
    { 
        y: 0,
        scale:1,
        duration: 1.2,
        ease: "pasiego",
        stagger: {
            from: 'start',
            amount: 0.2,
        },
         scrollTrigger: {
          trigger: '.about-methodology__image',
          start: 'top 90%', 
        
        }
    }
);


// RELATED

gsap.utils.toArray('.related').forEach(section => {
  const elems = section.querySelectorAll('.related-info');
  
  // Set things up
  gsap.set(elems, { y: 50, opacity: 0 });
  
  ScrollTrigger.create({
    trigger: section,
    start: 'top bottom',

    onEnter: () => gsap.to(elems, {
    delay: .2,
    duration: 1.2,
    y: 0,
    rotation: 0,
    opacity: 1,
    ease: "pasiego2",
      overwrite: 'auto',
        stagger: {
        from: 'start',
        amount: 0.3,
    },
        
    }),
    onLeaveBack: () => gsap.to(elems, {
      y: 50,
      opacity: 0,
      duration: .3,
      stagger: 0.1,
      delay: 0,
      ease: "pasiego2",
      overwrite: 'auto',
        stagger: {
        from: 'start',
        amount: 0.3,
    },
    })
  });
});


gsap.fromTo('.nav', {
    opacity: 0,
}, {
    delay: .1,
    duration: .4,
    opacity: 1,
    ease: "pasiego2",
    
});



//// SPLIT TEXT INTO LINES 

function splitLines(selector, options = {}) {
  const defaultOptions = {
    duration: 1,
    stagger: 0.15,
    ease: "pasiego2",
    yPercent: 100,
    opacity: 0,
    scrollTrigger: false
  };

  const config = { ...defaultOptions, ...options };
  const elements = document.querySelectorAll(selector);

  elements.forEach(element => {
    const nodes = Array.from(element.childNodes);
    const tempContainer = document.createElement('div');

    // 1. Recorrer los nodos y separarlos visualmente
    nodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.split(/(\s+)/);  // Separa por espacios
        words.forEach(word => {
          if (word.trim() !== '' || word === ' ') {
            const span = document.createElement('span');
            span.classList.add('word');
            span.textContent = word;
            tempContainer.appendChild(span);
          }
        });
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const wrapper = document.createElement('span');
        wrapper.classList.add('word');
        wrapper.appendChild(node.cloneNode(true)); // Clona la etiqueta (ejemplo <em>)
        tempContainer.appendChild(wrapper);
      }
    });

    element.innerHTML = '';
    element.appendChild(tempContainer);

    const wordSpans = Array.from(element.querySelectorAll('.word'));

    // 2. Detectar las líneas visuales reales (el salto de línea basado en el contenido visual)
    let lines = [];
    let currentLine = [];
    let lastTop = null;

    wordSpans.forEach(span => {
      const rect = span.getBoundingClientRect();
      const top = rect.top;

      if (lastTop === null) {
        lastTop = top;
      }

      // Verifica el corte de la línea visual cuando el "top" cambia significativamente
      if (Math.abs(top - lastTop) > 5) {
        lines.push(currentLine);  // Guardamos la línea anterior
        currentLine = [];         // Iniciamos una nueva línea
        lastTop = top;
      }
      currentLine.push(span);  // Añadimos el span actual a la línea actual
    });

    // Añadimos la última línea si existe
    if (currentLine.length) {
      lines.push(currentLine);
    }

    // 3. Reconstruir las líneas respetando las etiquetas (<em>, <strong>, etc.)
    element.innerHTML = '';

    lines.forEach(lineWords => {
      const line = document.createElement('div');
      line.classList.add('line');

      const inner = document.createElement('div');
      inner.classList.add('line-inner');

      // Procesamos los spans dentro de cada línea, manteniendo las etiquetas intactas
      lineWords.forEach(wordSpan => {
        while (wordSpan.firstChild) {
          inner.appendChild(wordSpan.firstChild);  // Añadimos los nodos hijos del span
        }
      });

      line.appendChild(inner);
      element.appendChild(line);
    });

    const lineInners = element.querySelectorAll('.line-inner');

    // 4. Animar las líneas con GSAP
    const animConfig = {
      yPercent: config.yPercent,
      opacity: config.opacity,
      stagger: config.stagger,
      duration: config.duration,
      ease: config.ease
    };

    if (config.scrollTrigger) {
      animConfig.scrollTrigger = {
        trigger: element,
        start: "top 80%",
        toggleActions: "play none none none",
        once: false
      };
    }

    gsap.from(lineInners, animConfig);
  });
}


// USO FLEXIBLE:

splitLines('.Split', {
    stagger: 0.1,
    duration: 1,
    ease: "pasiego2",
    yPercent: 50,
    opacity:0,
    scrollTrigger: true 
});

window.addEventListener('load', () => {
  splitLines('.Split2', {
    stagger: 0.1,
    duration: 1.2,
    ease: "pasiego2",
    yPercent: 50,
    opacity: 0
  });
});


document.querySelector('.nav-menu_icon').onclick = function(){
  document.querySelector('.menu-mobile').classList.add('active');
    document.querySelector('body').classList.add('active');
};

document.querySelector('.menu-works').onclick = function(){
  document.querySelector('.menu-mobile').classList.remove('active');
     document.querySelector('body').classList.remove('active');
};

document.querySelector('.menu-mobile_close').onclick = function(){
  document.querySelector('.menu-mobile').classList.remove('active');
     document.querySelector('body').classList.remove('active');
};

// DIVISIONS

document.querySelector('.header-more').onclick = function(){
document.querySelector('.container').classList.toggle('open');
document.querySelector('.divisions').classList.toggle('open');
document.querySelector('.nav').classList.toggle('open');
document.querySelector('.header').classList.toggle('open');
};


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


/// ANCHOR 

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    
    if (!targetElement) return;
    
    // Leer el offset del data-attribute del link o del target
    const customOffset = this.dataset.offset || targetElement.dataset.offset || 100;
    
    lenis.scrollTo(targetId, {
      offset: -parseInt(customOffset)
    });
  });
});

/// FIN ANCHOR 



!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).Ukiyo=e()}(this,(function(){"use strict";var t=function(t){return Array.prototype.slice.call(t)},e=function(){var t=window.navigator.userAgent,e=!!t.match(/iPad/i)||!!t.match(/iPhone/i),i=!!t.match(/WebKit/i);return e&&i&&!t.match(/CriOS/i)},i={scale:1.5,speed:1.5,wrapperClass:null,willChange:!1,externalRAF:!1},n=function(t,e){var n=this;if(this.element=t,this.wrapper=document.createElement("div"),this.options=Object.assign({},i,e),this.updateOptions(),this.vh=document.documentElement.clientHeight,this.isVisible=!1,this.damp=this.calcDamp(document.documentElement.clientWidth),this.elementTagName=this.element.tagName.toLowerCase(),"img"===this.elementTagName){var o=this.element.getAttribute("src");if(!o)return;(async function(t){var e=new Image;return e.src=t,await e.decode(),e})(o).then((function(){n.createParallax()}))}else this.createParallax()};n.prototype.createParallax=function(){this.setStyle(!0),this.wrapElement(),e()||this.createObserver()},n.prototype.updateOptions=function(){var t=this.element.getAttribute("data-p-scale"),e=this.element.getAttribute("data-p-speed"),i=this.element.getAttribute("data-p-willchange");null!==t&&(this.options.scale=Number(t)),null!==e&&(this.options.speed=Number(e)),null!==i&&(this.options.willChange=!0)},n.prototype.setStyle=function(t){void 0===t&&(t=!1);var e=this.element.clientHeight,i=this.element.clientWidth,n=window.getComputedStyle(this.element),o="absolute"===n.position,s=this.wrapper.style,r=this.element.style;this.overflow=Math.floor(10*(e-e*this.options.scale))/10,this.overflowAbs=Math.abs(this.overflow),o&&"0px"!==n.marginRight&&"0px"!==n.marginLeft&&n.marginLeft===n.marginRight&&(s.margin="auto"),"0px"===n.marginTop&&"0px"===n.marginBottom||(s.marginTop=n.marginTop,s.marginBottom=n.marginBottom,r.marginTop="0",r.marginBottom="0"),"auto"!==n.inset&&(s.top=n.top,s.right=n.right,s.bottom=n.bottom,s.left=n.left,r.top="0",r.right="0",r.bottom="0",r.left="0"),"none"!==n.transform&&(s.transform=n.transform),"auto"!==n.zIndex&&(s.zIndex=n.zIndex),s.position=o?"absolute":"relative","auto"!==n.gridArea&&"auto / auto / auto / auto"!==n.gridArea&&(s.gridArea=n.gridArea,r.gridArea="auto"),t&&(s.width="100%",s.overflow="hidden",r.display="block",r.overflow="hidden",r.backfaceVisibility="hidden","0px"!==n.padding&&(r.padding="0"),"img"===this.elementTagName?r.objectFit="cover":"video"!==this.elementTagName&&(r.backgroundPosition="center")),"0px"!==n.borderRadius&&(s.borderRadius=n.borderRadius,s.isolation||(s.isolation="isolate"),"0px"!==n.marginLeft&&(s.marginLeft=n.marginLeft,r.marginLeft="0"),"0px"!==n.marginRight&&(s.marginRight=n.marginRight,r.marginRight="0"),s.width=i+"px",r.width=i+"px"),o&&(s.width=i+"px",r.width="100%"),"none"!==n.maxHeight&&(s.maxHeight=n.maxHeight,r.maxHeight="none"),"0px"!==n.minHeight&&(s.minHeight=n.minHeight,r.minHeight="none"),s.height=e+"px",r.height=e*this.options.scale+"px",this.wrapperHeight=e},n.prototype.wrapElement=function(){var t=this.element.getAttribute("data-p-wrapper-class")||this.options.wrapperClass;t&&this.wrapper.classList.add(t);var e=this.element.closest("picture");if(null!==e)null!==e.parentNode&&e.parentNode.insertBefore(this.wrapper,e),this.wrapper.appendChild(e);else{var i=this.element.parentNode;null!==i&&i.insertBefore(this.wrapper,this.element),this.wrapper.appendChild(this.element)}},n.prototype.checkVisible=function(){var t=this.wrapper.getBoundingClientRect();0<t.bottom&&t.top<this.vh?this.onEnter():this.onLeave()},n.prototype.createObserver=function(){this.observer=new IntersectionObserver(this.handleIntersect.bind(this),{root:null,rootMargin:"0px",threshold:0}),this.observer.observe(this.wrapper)},n.prototype.handleIntersect=function(t){t[0].isIntersecting?this.onEnter():this.onLeave()},n.prototype.onEnter=function(){var t=this.element.style;this.options.willChange&&"transform"!==t.willChange&&(t.willChange="transform"),this.isVisible=!0},n.prototype.onLeave=function(){var t=this.element.style;this.options.willChange&&"transform"===t.willChange&&(t.willChange=""),this.isVisible=!1},n.prototype.calcTranslateValue=function(){var t=window.pageYOffset;t<0&&(t=0);var e=this.wrapper.getBoundingClientRect().top+t,i=(t+this.vh-e)/((this.vh+this.wrapperHeight)/100),n=Math.min(100,Math.max(0,i))/100,o=this.overflow+this.overflowAbs*n*this.options.speed*this.damp;return Number(o.toFixed(4))},n.prototype.calcDamp=function(t){var e=this.options.scale,i=this.options.speed;if((i>=1.4||e>=1.4)&&t<=1e3){e<1&&(e=1),i<1&&(i=1);var n=1.2-(1-(t/1e3+(3-(e+i)))),o=Math.max(.5,Math.min(1,n));return Math.floor(100*o)/100}return 1},n.prototype.transformParallax=function(){this.element.style.transform="translate3d(0 , "+this.calcTranslateValue()+"px , 0)"},n.prototype.animate=function(){e()&&this.checkVisible(),window.pageYOffset<0||this.isVisible&&this.transformParallax()},n.prototype.reset=function(){this.damp=this.calcDamp(window.innerWidth);var t=this.wrapper.style,e=this.element.style;this.vh=document.documentElement.clientHeight,t.width="",t.position="",t.height="100%",e.width="","img"===this.elementTagName&&"absolute"===t.position&&(t.height="100%"),""===t.gridArea?e.height="":e.height="100%","0px"!==t.margin&&(t.margin="",e.margin=""),"auto"!==t.inset&&(t.top="",t.right="",t.bottom="",t.left="",e.top="",e.right="",e.bottom="",e.left=""),"none"!==t.transform&&(t.transform="",e.transform=""),"auto"!==t.zIndex&&(t.zIndex=""),"0px"!==t.borderRadius&&(t.borderRadius="",t.isolation=""),this.setStyle(),this.transformParallax()},n.prototype.destroy=function(){var t;this.observer&&this.observer.disconnect(),this.wrapper.removeAttribute("style"),this.element.removeAttribute("style"),(t=this.wrapper).replaceWith.apply(t,this.wrapper.childNodes)};var o=function(e,i){if(this.elements=[],!e)throw new Error("Argument 'elements' is null.");var n,o;(this.elements=function(e){return Array.isArray(e)?e:"string"==typeof e?t(document.querySelectorAll(e)):e instanceof HTMLElement?[e]:e instanceof NodeList||e instanceof HTMLCollection?t(e):[e]}(e),this.options=i,this.instances=[],this.externalRAF=!(!this.options||!this.options.externalRAF)&&this.options.externalRAF,this.onResizeEvent=this.resize.bind(this),this.isInit=!1,n="undefined"!=typeof Promise&&-1!==Promise.toString().indexOf("[native code]"),o="undefined"!=typeof Element&&Element.prototype.closest,n&&o&&"IntersectionObserver"in window)&&this.init()};return o.prototype.init=function(){var t=this;this.isInit||(this.instances=this.elements.map((function(e){return new n(e,t.options)})),this.externalRAF||this.animate(),this.addEventListeners(),this.isInit=!0)},o.prototype.animate=function(){this.instances.forEach((function(t){t.animate()})),this.externalRAF||(this.requestId=window.requestAnimationFrame(this.animate.bind(this)))},o.prototype.cancel=function(){this.requestId&&window.cancelAnimationFrame(this.requestId)},o.prototype.reset=function(){this.instances.forEach((function(t){t.reset()}))},o.prototype.resize=function(){clearTimeout(this.timer),this.timer=window.setTimeout(this.reset.bind(this),500),this.reset.bind(this)},o.prototype.addEventListeners=function(){navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)?window.addEventListener("orientationchange",this.onResizeEvent):window.addEventListener("resize",this.onResizeEvent)},o.prototype.destroy=function(){this.cancel(),window.removeEventListener("resize",this.onResizeEvent),window.removeEventListener("orientationchange",this.onResizeEvent),this.instances.forEach((function(t){t.destroy()})),this.isInit=!1},o}));

const images = document.querySelectorAll(".parallax")
new Ukiyo(images)